import styles from './ArrowRight.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function ArrowRight() {
	return (
		<svg className={cx('arrow-right')} width="100%" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="m19.923 9.33-7.031 7.03a1.174 1.174 0 1 1-1.66-1.66l5.03-5.028H1.906a1.172 1.172 0 1 1 0-2.344h14.356l-5.029-5.031a1.174 1.174 0 1 1 1.66-1.66l7.032 7.031a1.172 1.172 0 0 1-.002 1.661Z" fill="#202020" />
		</svg>
	);
}
